import { render, staticRenderFns } from "./processInfo.vue?vue&type=template&id=2dc4160c&scoped=true"
import script from "./processInfo.vue?vue&type=script&lang=js"
export * from "./processInfo.vue?vue&type=script&lang=js"
import style0 from "./processInfo.vue?vue&type=style&index=0&id=2dc4160c&prod&lang=scss"
import style1 from "./processInfo.vue?vue&type=style&index=1&id=2dc4160c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc4160c",
  null
  
)

export default component.exports